import { render, staticRenderFns } from "./LeadershipCoachingAdmin.vue?vue&type=template&id=4e796fb5&scoped=true"
import script from "./LeadershipCoachingAdmin.vue?vue&type=script&lang=js"
export * from "./LeadershipCoachingAdmin.vue?vue&type=script&lang=js"
import style0 from "./LeadershipCoachingAdmin.vue?vue&type=style&index=0&id=4e796fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e796fb5",
  null
  
)

export default component.exports